import { render, staticRenderFns } from "./userpwd.vue?vue&type=template&id=964d24d2&scoped=true&"
import script from "./userpwd.vue?vue&type=script&lang=js&"
export * from "./userpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964d24d2",
  null
  
)

export default component.exports